import { Link } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import useWindowSize from "../hooks/useWindowSize";
import { MdMenuOpen } from "react-icons/md";
import WithAuthentication from "Authentication/AuthenticationContext";
import { URL_ID } from "constants/constants.js";
import { FaCampground, FaChartBar, FaMoneyBillWaveAlt, FaUsersCog, FaUserTie, FaTicketAlt, FaList, FaUserAlt, FaShoppingBasket } from "react-icons/fa";
import { AiFillSetting, AiOutlineTransaction } from "react-icons/ai";
export default function CustomerSidebar() {
  const auth = useContext(WithAuthentication);
  function getButtonIcon(id: number): JSX.Element | undefined {
    switch (id) {
      case URL_ID.adminTourList.id:
        return <FaList className="fs-5"></FaList>;
      case URL_ID.adminCreateTour.id:
        return <FaCampground className="fs-18" />;
      case URL_ID.adminUserManagement.id:
        return <FaUsersCog className="fs-5" />;
      case URL_ID.adminUserReport.id:
        return <FaUserTie className="fs-5" />;
      case URL_ID.adminManagement.id:
        return <FaChartBar className="fs-18 " />;
      case URL_ID.adminFinancial.id:
        return <FaMoneyBillWaveAlt className="fs-5" />;
      case URL_ID.adminReservation.id:
        return <FaTicketAlt className="fs-5" />;
      case URL_ID.customerProfile.id:
        return <FaUserAlt className="fs-5" />;
      case URL_ID.customerDashboard.id:
        return <AiFillSetting className="fs-5" />;
      case URL_ID.customerTransactions.id:
        return <AiOutlineTransaction className="fs-5" />;
      case URL_ID.customerOrders.id:
        return <FaShoppingBasket className="fs-5" />;
    }
  }
  function addExtraButtons(): JSX.Element[] {
    let buttonsJSX: JSX.Element[] = [];
    let myAccessLevel = auth.userInfo.accessLevel;
    if (typeof myAccessLevel != "string") {
      myAccessLevel = myAccessLevel.toString();
    }
    for (const key in URL_ID) {
      if (myAccessLevel.split(",").find((value) => URL_ID[key].id == value)) {
        buttonsJSX.push(
          <li className="nav-item d-block  rounded  size5 side-link w-100">
            <Link to={URL_ID[key].route} exact className=" nav-link align-middle px-0 d-flex">
              {getButtonIcon(URL_ID[key].id)}
              <div className="w-100 ms-2 ">{URL_ID[key].name}</div>
            </Link>
          </li>
        );
      }
    }

    return buttonsJSX;
  }
  const [isOpen, setIsOpen] = useState(false);
  const { width }: { width: number | undefined } = useWindowSize();
  useEffect(() => {
    if (width && width > 992 && isOpen === false) {
      setIsOpen(true);
    }
    if (width && width < 992 && isOpen === true) {
      setIsOpen(false);
    }
  }, [width]);
  return (
    <>
      {width && width < 992 && (
        <button
          className="btn btn-mobile-menu"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <MdMenuOpen></MdMenuOpen>
        </button>
      )}
      {isOpen && (
        <>
          <div className={`d-block  flex-nowrap navbar-expand-md d-block ${width && width < 992 && "mobile-customer-sidebar"}`}>
            <div className={`rounded sidebar d-flex flex-column flex-nowrap ${width && width < 992 && "mx-0"}`} id="navbarTogglerDemo01" style={{ width: "250px" }}>
              <div className="pic rounded-circle mx-auto mt-5 mb-3" style={{ overflow: "hidden" }}>
                <img src={auth.userInfo.profilePicture} alt="" style={{ width: "100%", height: "100%" }} />
              </div>
              <div className="m-2 size5 d-none d-sm-block ">{auth.userInfo.fullName}</div>
              <div className=" nav nav-pills flex-column col-12 ">{addExtraButtons()}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
